<template>
  <main id="activity-feed">
    <h6 class="left-align">Activity Feed</h6>
    <article v-for="evt in evts" :key="evt.id">
      <event-rating-transaction :evt="evt" v-if="evt.event_type === 'rating-transaction'" />
    </article>
  </main>
</template>

<script>
import axios from 'axios';
import EventRatingTransaction from '@/components/EventRatingTransaction.vue';

export default {
  name: 'ActivityFeed',
  components: { EventRatingTransaction },
  props: {
    companyId: {
      type: Number,
      required: false,
      default: 0,
    },
    analystId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      evts: [],
      enableInfiniteScroll: true,
      limit: 50,
      offset: 0,
      eventType: 'rating-transaction',
    };
  },
  computed: {
    isFarmTeamer() {
      return this.$auth.hasRoles('farm-team');
    },
  },
  watch: {
    eventType() {
      this.evts = [];
      this.offset = 0;
      this.paginate();
    },
  },
  methods: {
    initInifiteScroll() {
      window.onscroll = evt => {
        if (document.getElementById('activity-feed') && (window.innerHeight + window.pageYOffset) >= document.body.offsetHeight) {
          // Infinite scroll is buggy and will fire multiple times unless listener is disabled explicitly by this.scrollEnabled
          if (this.enableInfiniteScroll) {
            this.paginate();
          }
        }
      };
    },
    async paginate() {
      this.enableInfiniteScroll = false;
      let baseUrl = `${this.$store.getters.VUE_APP_APING_URL}/insights/activities/events/?limit=${this.limit}&offset=${this.offset}`;
      if (this.companyId) {
        baseUrl += `&company_id=${this.companyId}`;
      }
      if (this.analystId) {
        baseUrl += `&analyst_id=${this.analystId}`;
      }
      if (this.isFarmTeamer) {
        baseUrl += `&farm_team_only=${true}`;
      }
      if (this.eventType) {
        baseUrl += `&event_type=${this.eventType}`;
      }
      const { data } = await axios.get(baseUrl);
      data.forEach(evt => {
        this.evts.push(evt);
      });
      this.offset += 50;
      this.enableInfiniteScroll = true;
    },
  },
  async mounted() {
    this.initInifiteScroll();
    this.paginate();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.controls > label {
  margin-right: 20px;
}
</style>
